module.exports = __webpack_public_path__ + "static/media/pra-reward.09aad430.png";